var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',{staticClass:"main-footer fixed-bottom"},[_c('NewsTicker'),_c('AppBottomNavBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }